export const easeIn = '0.3s ease-in';
export const easeInOut = '0.35s ease-in-out';
export const easeInOutLong = '0.5s ease-in-out';
